// * Constantes

const AUTOMATIC_MESSAGE = "---------------------------------------------<br>Nuestro centro de atención al cliente y postventa ya está revisando su caso <br> recibirá un correo electrónico cuando sea respondido. <br>---------------------------------------------";

const MEDIO_PAGO = { 
        creditCard      : 'Tarjeta de crédito', 
        debitCard       : 'Tarjeta de débito',
        giftCard        : 'GiftCard',
        MercadoPago     : 'Mercado Pago',
        MercadoPagoPro  : 'Mercado Pago',
        promissory      : 'Promissory',
        Ticket          : 'Ticket',
}
const ESTADO_REEMBOLSO = { 
        '': 'Pendiente',
        approved: 'Aprobado',
        authorized : 'Autorizado',
        cancelled  : 'Cancelado',
        charged_ba : 'Cargado',
        in_process : 'En proceso',
        refunded   : 'Reintegro', 
        rejected   : 'Rechazado',
     
}


// * Funciones

//? Método para darle formato a la url
var formatUrl = function (value, type) {
    if (type === "url" && value.length > 50) value = value.slice(0, 50) + "…";
    return value;
  }


export {
    AUTOMATIC_MESSAGE,
    formatUrl,
    MEDIO_PAGO,
    ESTADO_REEMBOLSO,
}